import { render, staticRenderFns } from "./SimcardList.vue?vue&type=template&id=27973a3e&scoped=true&"
import script from "./SimcardList.vue?vue&type=script&lang=js&"
export * from "./SimcardList.vue?vue&type=script&lang=js&"
import style0 from "./SimcardList.vue?vue&type=style&index=0&id=27973a3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27973a3e",
  null
  
)

export default component.exports